import { render, staticRenderFns } from "./ForecastUOApp6.vue?vue&type=template&id=dbff5804&"
import script from "./ForecastUOApp6.vue?vue&type=script&lang=js&"
export * from "./ForecastUOApp6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports